// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"styles_collapsible__yttFH","animatedContents":"styles_animatedContents__F8AVw"};